export default __webpack_public_path__ + "static/media/express_plan_delivery@2x.a3d9ba72.png";